import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, Stack, Fade } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const slides = [
  {
    image: '/sports.png',
    subtitle: 'SPORTS EXCELLENCE',
    title: 'Sports Rehabilitation',
    description: 'Get back to your peak performance with our specialized sports rehabilitation programs. Expert sports physiotherapy near me in Bangalore for athletes and sports enthusiasts.',
    buttonStyle: {
      primary: {
        background: '#6B46C1',
        hover: '#553C9A'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/ortho.png',
    subtitle: 'EXPERT CARE',
    title: 'Orthopedic Physiotherapy',
    description: 'Expert orthopedic physiotherapy treatment for musculoskeletal conditions, joint pain, and post-injury rehabilitation in Bangalore.',
    buttonStyle: {
      primary: {
        background: '#2B6CB0',
        hover: '#2C5282'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/Manual.png',
    subtitle: 'SPECIALIZED TREATMENT',
    title: 'Manual Therapy',
    description: 'Specialized manual therapy physiotherapy hands-on treatment techniques to reduce pain, improve joint mobility, and restore muscle function at home.',
    buttonStyle: {
      primary: {
        background: '#38A169',
        hover: '#2F855A'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/Cardiac.png',
    subtitle: 'HEART HEALTH',
    title: 'Cardiac Rehabilitation',
    description: 'Comprehensive cardiac rehabilitation program for heart patients, focusing on safe exercise progression and heart health with home physiotherapy services.',
    buttonStyle: {
      primary: {
        background: '#E53E3E',
        hover: '#C53030'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/womenhealth.png',
    subtitle: 'WOMEN\'S WELLNESS',
    title: 'Women\'s Health Physiotherapy',
    description: 'Specialized women\'s health physiotherapy services designed specifically for women\'s unique health needs throughout all life stages including postpartum physiotherapy at home.',
    buttonStyle: {
      primary: {
        background: '#D53F8C',
        hover: '#B83280'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/Vestibular.png',
    subtitle: 'BALANCE RESTORATION',
    title: 'Vestibular Rehabilitation',
    description: 'Specialized vestibular rehabilitation treatment for dizziness, vertigo, and balance disorders to improve stability and quality of life with physiotherapy near me.',
    buttonStyle: {
      primary: {
        background: '#805AD5',
        hover: '#6B46C1'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/homecare.png',
    subtitle: 'COMFORT OF HOME',
    title: 'Home Care Physiotherapy',
    description: 'Professional home physiotherapy care in the comfort of your home, bringing expert physiotherapist at home directly to you in Bangalore.',
    buttonStyle: {
      primary: {
        background: '#319795',
        hover: '#2C7A7B'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/geriatric.png',
    subtitle: 'SENIOR CARE',
    title: 'Geriatric Physiotherapy',
    description: 'Specialized elderly physiotherapy care for elderly patients focusing on improving mobility, balance, and overall quality of life with home physiotherapy for elderly.',
    buttonStyle: {
      primary: {
        background: '#DD6B20',
        hover: '#C05621'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/postsurgical.png',
    subtitle: 'RECOVERY EXPERTISE',
    title: 'Post-Surgical Rehabilitation',
    description: 'Specialized post-surgical physiotherapy rehabilitation programs for optimal recovery after surgical procedures with personalized care plans at home.',
    buttonStyle: {
      primary: {
        background: '#3182CE',
        hover: '#2B6CB0'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/neuro.png',
    subtitle: 'NEUROLOGICAL CARE',
    title: 'Neurological Rehabilitation',
    description: 'Expert neuro physiotherapy care for patients with neurological conditions, focusing on improving function and independence with stroke rehabilitation.',
    buttonStyle: {
      primary: {
        background: '#2C5282',
        hover: '#2A4365'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/Paediatric.png',
    subtitle: 'CHILD DEVELOPMENT',
    title: 'Pediatric Physiotherapy',
    description: 'Specialized pediatric physiotherapy services for children, addressing developmental delays and pediatric conditions with home physiotherapy for kids.',
    buttonStyle: {
      primary: {
        background: '#38B2AC',
        hover: '#319795'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  },
  {
    image: '/electrotherapy.png',
    subtitle: 'ADVANCED TREATMENT',
    title: 'Electrotherapy',
    description: 'Advanced electrotherapy electrical stimulation treatments including IFT physiotherapy and TENS therapy to reduce pain and improve muscle function through targeted therapy.',
    buttonStyle: {
      primary: {
        background: '#4299E1',
        hover: '#3182CE'
      },
      secondary: {
        borderColor: 'rgba(255, 255, 255, 0.8)',
        color: 'white'
      }
    }
  }
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      component="section"
      id="hero"
      sx={{
        position: 'relative',
        height: { xs: 'calc(100vh - 64px)', md: '100vh' },
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.4))',
          pointerEvents: 'none',
          zIndex: 1
        }
      }}
    >
      {slides.map((slide, index) => (
        <Box
          key={index}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: activeSlide === index ? 1 : 0,
            transition: 'opacity 0.8s ease-in-out'
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `url(${slide.image})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              transform: activeSlide === index ? 'scale(1.1)' : 'scale(1)',
              transition: 'transform 8s ease'
            }}
          />
          <Container
            maxWidth="lg"
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
              zIndex: 2
            }}
          >
            <Box
              sx={{
                maxWidth: 800,
                opacity: activeSlide === index ? 1 : 0,
                transform: activeSlide === index ? 'translateY(0)' : 'translateY(20px)',
                transition: 'all 0.8s ease-in-out 0.3s'
              }}
            >
              <Fade in={activeSlide === index} timeout={1000}>
                <Box
                  component="img"
                  src="/new logo.png"
                  alt="CareFlex Physiotherapy - Best Home Physiotherapy Services in Bangalore, Physio Near Me"
                  sx={{
                    width: { xs: '120px', sm: '150px', md: '180px' },
                    height: 'auto',
                    mb: 4,
                    filter: 'brightness(0) invert(1)',
                    animation: 'floatAnimation 3s ease-in-out infinite',
                    '@keyframes floatAnimation': {
                      '0%, 100%': {
                        transform: 'translateY(0)'
                      },
                      '50%': {
                        transform: 'translateY(-10px)'
                      }
                    }
                  }}
                />
              </Fade>
              <Typography
                variant="subtitle1"
                sx={{
                  color: '#00E5BE',
                  fontWeight: 600,
                  letterSpacing: '2px',
                  mb: 2,
                  fontSize: { xs: '0.9rem', sm: '1rem' }
                }}
              >
                {slide.subtitle}
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  mb: 2,
                  lineHeight: 1.1,
                  fontFamily: "'Poppins', sans-serif"
                }}
              >
                {slide.title}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  color: 'rgba(255,255,255,0.9)',
                  mb: 4,
                  textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                  maxWidth: '80%',
                  lineHeight: 1.6,
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.4rem' }
                }}
              >
                {slide.description}
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate('/book-appointment')}
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                    background: slide.buttonStyle.primary.background,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      background: slide.buttonStyle.primary.hover,
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 25px rgba(0,0,0,0.4)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Start Recovery
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  endIcon={<ArrowForward />}
                  onClick={() => navigate('/services')}
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                    borderWidth: 2,
                    borderRadius: '50px',
                    borderColor: slide.buttonStyle.secondary.borderColor,
                    color: 'white',
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      borderColor: 'white',
                      background: 'rgba(255,255,255,0.1)',
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Learn More
                </Button>
              </Stack>
            </Box>
          </Container>
        </Box>
      ))}
    </Box>
  );
};

export default HeroSection; 